import React, { ChangeEvent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../../../../store/reducers';
import { searchFilter } from '../../../../store/actions';
import { SearchProduct } from '../../../molecules/FilterBar/SearchProduct';

const SearchProductInput = () => {
  const search = useSelector((state: AppState) => state.productFilter.search);
  const dispatch = useDispatch();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(searchFilter(e.target.value));
  };

  return <SearchProduct value={search} onChange={onChange} />;
};

export default SearchProductInput;
